(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/event-list/assets/javascripts/event-list.js') >= 0) return;  svs.modules.push('/components/marketplace/event-list/assets/javascripts/event-list.js');
"use strict";


const EventListItem = svs.components.marketplace.eventList.EventListItem;
const EventList = _ref => {
  let events = _ref.events,
    warningMessage = _ref.warningMessage,
    isOneMatchGame = _ref.isOneMatchGame,
    oneGameMatchDescription = _ref.oneGameMatchDescription,
    productId = _ref.productId;
  return React.createElement("div", {
    className: "event-list-container margin-bottom-2"
  }, warningMessage ? React.createElement("div", {
    className: "align-center"
  }, React.createElement("h3", {
    className: "f-content f-700 f-medium margin-bottom-1"
  }, "Radskiss"), React.createElement("span", {
    className: "fc-grey-500"
  }, warningMessage)) : null, events.length > 0 && React.createElement("div", {
    className: "event-list"
  }, React.createElement("ul", {
    className: "list-group event-list-component"
  }, React.createElement("li", null, React.createElement("div", {
    className: "event-list-row event-list-row-header"
  }, React.createElement("h5", {
    className: "event-description-header fc-grey-600 f-uppercase"
  }, "MATCHER"), React.createElement("h5", {
    className: "event-date-header fc-grey-600 f-uppercase"
  }, "START")), isOneMatchGame ? React.createElement("div", {
    className: "padding-xs"
  }, oneGameMatchDescription) : null), events.map(event => React.createElement(EventListItem, {
    event: event,
    key: event.eventNumber,
    productId: productId
  })))));
};
EventList.defaultProps = {
  events: []
};
setGlobal('svs.components.marketplace.eventList.EventList', EventList);

 })(window);